var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"title":_vm.title,"width":"1500px","in-dialog":_vm.inDialog}},[_c('list',{ref:"list"}),_c('template',{slot:"footer"},[_vm._t("footer",function(){return [_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.selectData}},[_vm._v("选择")])]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }